const messages: Record<string, string> = {
  EDITORIAL_APPROVAL_REQUIRED:
    'Esta publicação precisa de uma pauta aprovada. Abra o Editorial, revise e aprove a pauta vinculada à mídia.',
  FINAL_ASSET_REQUIRED:
    'A publicação precisa de um asset FINAL validado. Aguarde o agente concluir a renderização ou escolha outro asset.',
  ACCOUNT_NOT_CONNECTED:
    'A conta de destino não está conectada. Reconecte-a em Conexões antes de agendar.',
  REMOTE_MEDIA_NOT_CONFIGURED:
    'A URL pública e assinada da mídia ainda não está configurada na API. Verifique a configuração do Worker.',
  AUTOMATION_PAUSED:
    'As automações estão pausadas. Retome-as no painel quando for seguro continuar.',
  INVALID_MASTER_TIMEZONE:
    'Data, hora ou fuso inválido. Escolha um horário futuro e um fuso IANA válido.',
  MEDIA_JOB_FAILED:
    'Não foi possível criar o job de mídia. Confira a pauta, o original e o template; se persistir, consulte os logs.',
  SOURCE_ASSET_NOT_FOUND:
    'O original selecionado não está disponível ou não foi validado. Importe outro arquivo.',
  EDITORIAL_ITEM_NOT_FOUND:
    'A pauta selecionada não está mais disponível. Atualize a Fábrica e selecione novamente.',
  INVALID_TEMPLATE:
    'O template não está disponível para esse formato. Escolha outro template.',
  POLICY_LEAD_TIME:
    'Esse destino exige mais antecedência. Escolha um horário posterior ou revise a política da conta.',
  EXPLICIT_CONSENT_REQUIRED:
    'Confirme o consentimento específico exigido pela plataforma antes de agendar.',
  RETRY_NOT_SAFE:
    'Não é seguro repetir este envio automaticamente. Reconcilie a publicação antes de tentar novamente.',
};

export function friendlyApiError(code?: string, fallback?: string): string {
  if (code && messages[code]) return messages[code];
  if (fallback) return fallback;
  return code && /^[A-Z][A-Z0-9_]{2,80}$/.test(code)
    ? `A operação não foi concluída (${code}). Consulte o histórico para detalhes.`
    : 'Não foi possível concluir a solicitação. Tente novamente.';
}
